import { render } from "./component-adress-mail.vue?vue&type=template&id=109a9d8a"
import script from "./component-adress-mail.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-mail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-mail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "109a9d8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('109a9d8a', __exports__)) {
    api.reload('109a9d8a', __exports__)
  }
  
  module.hot.accept("./component-adress-mail.vue?vue&type=template&id=109a9d8a", () => {
    api.rerender('109a9d8a', render)
  })

}


export default __exports__